export class ResultadoFiltroDemandaVO {

  manifestos: Array<any>;
  totalPaginas: number;

  constructor() {

    this.manifestos = [];
    this.totalPaginas = 0;

  }

}
